@use 'styles/colors' as *;
@use 'styles/functions/rem' as *;

.warningNotification {
    background-color: $warningNotificationBackgroundColor;
    height: rem(46px);
}
